import Axios from 'axios';
import * as SchoolRequest from '@/models/schoolRequest';
import * as SchoolResponse from '@/models/schoolResponse';
import { FunctionTypes } from '@/enums/functionTypes';

export type School = SchoolResponse.SchoolDetail;

export interface SearchCondition {
  keyWord: string;
  perPage: number;
  page: number;
  sort: string;
}

interface State {
  loading: boolean;
  countAll: number;
  schools: School[];
  searchCondition: SearchCondition;
}
const mapState: State = {
  loading: false,
  countAll: 0,
  schools: new Array<School>(),
  searchCondition: {
    keyWord: '',
    perPage: 20,
    page: 1,
    sort: '',
  },
};

const mapActions = {
  async searchSchools({ commit }: any, searchCondtion: SearchCondition) {
    commit('setLoading', true);

    const request: SchoolRequest.SchoolRequest = {
      schoolId: undefined,
      schoolName: undefined,
      ownerId: undefined,
      note: undefined,
      paymentMailaddress: undefined,
      subjectList: undefined,
      keyWord: searchCondtion.keyWord,
      perPage: searchCondtion.perPage,
      page: searchCondtion.page,
      sort: searchCondtion.sort,
      availableFunctionbit: undefined,
      availableFunctionTypes: undefined,
      reservableMonths: undefined,
      cancellationDays: undefined,
      isAutoEntryOrExit: undefined,
      collectionAgency: undefined,
    };
    const response = await Axios.post('/api/School/Search', request).catch((error) => {
      commit('setLoading', false);
      throw error;
    });
    commit('searchSchools', response.data);
  },
  async createSchool({ commit }: any, school: School) {
    if (!school || !school.schoolName) {
      throw new Error('スクール名を入力してください。');
    }
    const request: SchoolRequest.OrdinarySchoolEditRequest = {
      schoolId: school.schoolId,
      schoolName: school.schoolName,
      ownerId: school.ownerId,
      note: school.note,
      paymentMailaddress: school.paymentMailaddress,
      subjectList: undefined,
      ordinarySchoolList: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: undefined,
      availableFunctionTypes: school.availableFunctionTypes,
      reservableMonths: school.reservableMonths,
      cancellationDays: school.cancellationDays,
      isAutoEntryOrExit: school.isAutoEntryOrExit,
      collectionAgency: school.collectionAgency,
    };
    const response = await Axios.post('/api/School/Create', request).catch((error) => {
      throw new Error('スクール登録に失敗しました。');
    });
    commit('addSchool', school);
    return response.data;
  },
  async editSchool({ commit }: any, school: School) {
    if (!school || !school.schoolName) {
      throw new Error('スクール名を入力してください。');
    }

    const request: SchoolRequest.OrdinarySchoolEditRequest = {
      schoolId: school.schoolId,
      schoolName: school.schoolName,
      ownerId: school.ownerId,
      note: school.note,
      paymentMailaddress: school.paymentMailaddress,
      subjectList: undefined,
      ordinarySchoolList: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: school.availableFunctionbit,
      availableFunctionTypes: school.availableFunctionTypes,
      reservableMonths: school.reservableMonths,
      cancellationDays: school.cancellationDays,
      isAutoEntryOrExit: school.isAutoEntryOrExit,
      collectionAgency: school.collectionAgency,
    };
    const response = await Axios.post('/api/School/Edit', request).catch((error) => {
      throw new Error('スクール変更に失敗しました。');
    });
    commit('changeSchool', school);
    return response.data;
  },
  async deleteSchool({ commit }: any, schoolId: string) {
    if (!schoolId) {
      throw new Error('削除するスクールを選択してください。');
    }
    const request: SchoolRequest.OrdinarySchoolEditRequest = {
      schoolId,
      schoolName: undefined,
      ownerId: undefined,
      note: undefined,
      paymentMailaddress: undefined,
      subjectList: undefined,
      ordinarySchoolList: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: undefined,
      availableFunctionTypes: undefined,
      reservableMonths: undefined,
      cancellationDays: undefined,
      isAutoEntryOrExit: undefined,
      collectionAgency: undefined,
    };
    const response = await Axios.post('/api/School/Delete', request).catch((error) => {
      throw new Error('スクール削除に失敗しました。');
    });
    commit('removeSchool', schoolId);
    return response.data;
  },
  async getSchool({ commit }: any, schoolId: string) {
    const request: SchoolRequest.SchoolRequest = {
      schoolId,
      schoolName: undefined,
      ownerId: undefined,
      note: undefined,
      paymentMailaddress: undefined,
      subjectList: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: undefined,
      availableFunctionTypes: undefined,
      reservableMonths: undefined,
      cancellationDays: undefined,
      isAutoEntryOrExit: undefined,
      collectionAgency: undefined,
    };
    const response = await Axios.post('/api/School/Detail', request).catch((error) => {
      throw error;
    });
    return response.data as School;
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  searchSchools(state: State, data: SchoolResponse.SchoolListResponse) {
    state.countAll = data.countAll;
    state.schools = data.schoolList;
    state.loading = false;
  },
  addSchool(state: State, school: School) {
    state.schools.push(school);
  },
  changeSchool(state: State, school: School) {
    const findIndex = state.schools.findIndex((value) => {
      return (value.schoolId === school.schoolId);
    });
    if (findIndex >= 0) {
      state.schools.splice(findIndex, 1, {
        ...school,
        tutorCount: state.schools[findIndex].tutorCount,
        studentCount: state.schools[findIndex].studentCount,
      });
    }
  },
  removeSchool(state: State, schoolId: string) {
    const findIndex = state.schools.findIndex((value) => {
      return (value.schoolId === schoolId);
    });
    if (findIndex >= 0) {
      state.schools.splice(findIndex, 1);
    }
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
